namespace SorAraBul.Definitions {
    export interface OccupationForm {
        Code: Serenity.StringEditor;
        Name: Serenity.StringEditor;
    }

    export class OccupationForm extends Serenity.PrefixedContext {
        static formKey = 'Definitions.Occupation';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OccupationForm.init)  {
                OccupationForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(OccupationForm, [
                    'Code', w0,
                    'Name', w0
                ]);
            }
        }
    }
}
